module.exports = __webpack_public_path__ + "static/air_elemental_myrmidon-fbea21fc601a2d54c5fa90038706d5c5.png";